import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import firebase from '../Configs/firebase'
import Plan from '../Models/Plan';

class List extends Component{
    constructor(props){
        super(props)
        this.state = {
            lists:[]
        }

        this.getMyList = this.getMyList.bind(this)
        this.getSavedList = this.getSavedList.bind(this)
        this.handleDelete = this.handleDelete.bind(this)
        this.updateList = this.updateList.bind(this)
    }

    componentDidMount(){
        const {owner} = this.props
        new Promise((resolve,reject)=>{
            if( owner === 'my'){
                resolve(this.getMyList())
            }else{
                resolve(this.getSavedList())
            }
        })
        .then(snapshots=>{
            var planArr = []
            snapshots.forEach(plan=>{
                var planObj = Plan.initBySnapshot(plan)
                planArr.push(planObj)
            })

            this.setState({lists:planArr})
        })
    }

    getMyList(){
        return firebase.firestore().collection(this.props.mode+'s').where('uid','==',firebase.auth().currentUser.uid).orderBy('updated_date','desc').get()
    }

    getSavedList(){
        return firebase.firestore().collection(this.props.mode+'s').where('saved_uid.'+firebase.auth().currentUser.uid,'>',new Date(1155784914)).orderBy('saved_uid.'+firebase.auth().currentUser.uid,'desc').get()
    }

    updateList(snapshots){
        var planArr = []
        snapshots.forEach(plan=>{
            var planObj = Plan.initBySnapshot(plan)
            planArr.push(planObj)
        })

        this.setState({lists:planArr})
    }

    handleDelete(e,plan){
        const { owner } = this.props
        var ans = window.confirm('คุณต้องการลบ '+plan.name+' ใช่หรือไม่')
        if( ans ){
            if(owner === 'my'){
                firebase.firestore().collection('shapes').where('plan','==',plan.uid).get()
                .then(docs=>{
                    docs.forEach(doc=>{
                        firebase.firestore().collection('shapes').doc(doc.id).delete()
                    })
                })
                .then(()=>{
                    return firebase.firestore().collection('plans').doc(plan.uid).delete()
                })
                .then(()=>{
                    return this.getMyList()
                })
                .then(snapshots=>{
                    this.updateList(snapshots)
                })
            }
            else{
                delete plan.savedUid[firebase.auth().currentUser.uid]
                firebase.firestore().collection('plans').doc(plan.uid).update({
                    saved_uid:plan.savedUid
                })
                .then(()=>{
                    return this.getSavedList()
                })
                .then(snapshots=>{
                    this.updateList(snapshots)
                })
            }
        }
    }
    
    render(){
        const { lists } = this.state
        const { mode } = this.props
        var listPlan = <label className="is-center">คุณยังไม่มีแปลงใดๆ</label>
        var dropdown = null
        var image = "/Images/drone_data@3x.png"
        
        if( lists.length > 0 ){
            listPlan = lists.map((plan,index)=>{
                if ( mode === 'plan'){
                    dropdown =  <div className="list-more-button dropdown">
                                    <div className="dropbtn">
                                        <i className="fas fa-ellipsis-h is-right"></i>
                                        <div className="dropdown-content">
                                            <div onClick={(e)=>this.handleDelete(e,plan)}>ลบแปลง</div>
                                        </div>
                                    </div>
                                </div>
                    image = "/Images/my_plan@3x.png"
                }
                return (
                    <div className="box" key={index}>
                        <div className="is-list">
                            <Link className="icon-and-text" to={'/'+mode+'/'+plan.uid} replace>
                                <div className="list-icon">
                                    <img src={image} alt="Plan" width="24" height="24"/>
                                </div>
                                <div className="list-text">
                                    <label className="is-plan-name"> {plan.name}</label>
                                    <label className="is-plan-date"> แก้ไขล่าสุดเมื่อ {plan.updatedAtString()}</label>
                                </div>
                            </Link>
                            { dropdown }
                        </div>
                    </div>

                )
            })
        }

        return(
            <div className="UserMenu">
                <div className="box">
                    <div className="ListHeader">
                        <span onClick={this.props.handleShow1stMenu} className="BackMenu"><i className="fas fa-arrow-left"></i></span>
                        <span onClick={this.props.handleClose} className="CloseMenu"><i className="fas fa-times"></i></span>    
                    </div>
                    {listPlan}
                </div>
            </div>
        )
    }
}

export default List


// WEBPACK FOOTER //
// ./src/PageMaps/_List.js